<div class="form-component">
    <h4>
        Define Sales Data Rows to Import
    </h4>
    <span>To view the data for a specific worksheet, select the 'Preview' button located beside that worksheet</span>

    <form #form="ngForm">
        <div class="import-config-wrapper">
            <table class="import-config-table">
                <thead>
                    <tr>
                        <th>Worksheet Name</th>
                        <th>Header Row</th>
                        <th>Start Row</th>
                        <th>End Row</th>
                        <th class="preview-cell"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let worksheet of selectedWorksheets; let i = index">
                        <td>{{ worksheet.worksheetName }}</td>
                        <td>
                            <div class="input-field">
                                <input type="number"
                                       id="headerIndex{{i}}"
                                       name="headerIndex{{i}}"
                                       [(ngModel)]="worksheet.headerIndex"
                                       required />
                            </div>
                        </td>
                        <td>
                            <div class="input-field">
                                <input type="number"
                                       id="startIndex{{i}}"
                                       name="startIndex{{i}}"
                                       [(ngModel)]="worksheet.startIndex"
                                       required />
                            </div>
                        </td>
                        <td>
                            <div class="input-field">
                                <input type="number"
                                       id="endIndex{{i}}"
                                       name="endIndex{{i}}"
                                       [(ngModel)]="worksheet.endIndex"
                                       required />
                            </div>
                        </td>
                        <td class="preview-cell">
                            <button type="button"
                                    class="preview-button"
                                    (click)="getWorksheetSample(filePath, worksheet.worksheetName); selectedPreview = worksheet">
                                Preview
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>

<h4 class="secondary-header">
    Excel data preview
    <span *ngIf="selectedPreview?.worksheetName">({{ selectedPreview?.worksheetName }})</span>
</h4>

<div class="data-preview-container" [class.wide]="isWideTable" *ngIf="!loading && (firstTenRows.length > 0 || lastTenRows.length > 0); else loadingOrNoData">
    <table class="data-preview-table" [class.wide]="isWideTable">
        <thead>
            <tr [class.header-row]="firstTenRows[0]?.rowNumber === selectedPreview?.headerIndex">
                <th>{{firstTenRows[0]?.rowNumber}}</th>
                <th *ngFor="let header of firstTenRows[0]?.rowValues">{{ header || '' }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of firstTenRows.slice(1)"
                [class.header-row]="row?.rowNumber === selectedPreview?.headerIndex"
                [class.start-row]="row?.rowNumber === selectedPreview?.startIndex"
                [class.end-row]="row?.rowNumber === selectedPreview?.endIndex">
                <td>{{row?.rowNumber}}</td>
                <td *ngFor="let cell of row?.rowValues">{{ cell || '' }}</td>
            </tr>
            <tr>
                <td [attr.colspan]="firstTenRows[0]?.rowValues?.length || 1"></td>
            </tr>
            <tr *ngFor="let row of lastTenRows"
                [class.header-row]="row?.rowNumber === selectedPreview?.headerIndex"
                [class.start-row]="row?.rowNumber === selectedPreview?.startIndex"
                [class.end-row]="row?.rowNumber === selectedPreview?.endIndex">
                <td>{{row?.rowNumber}}</td>
                <td *ngFor="let cell of row?.rowValues">{{ cell || '' }}</td>
            </tr>
        </tbody>
    </table>
</div>

<ng-template #loadingOrNoData>
    <div *ngIf="loading" class="loading-indicator">
        <div class="spinner"></div>
        Loading Excel data... This may take a moment for larger files.
    </div>
    <ng-container *ngIf="!loading">
        <p>No data available to preview. Please verify your selections.</p>
    </ng-container>
</ng-template>